export const SET_SUBSCRIPTION = 'SUBSCRIPTION/SET_SUBSCRIPTION';
export const SET_IS_PLAN_360 = 'SUBSCRIPTION/SET_IS_PLAN_360';
